__turbopack_context__.v({
  "ant-dropdown-menu": "index-module-scss-module__Evg8tq__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__Evg8tq__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__Evg8tq__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__Evg8tq__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__Evg8tq__back-top-wrap",
  "container": "index-module-scss-module__Evg8tq__container",
  "filterTableSelect": "index-module-scss-module__Evg8tq__filterTableSelect",
  "icon": "index-module-scss-module__Evg8tq__icon",
});
